import { JetView } from 'webix-jet';

/**
 * PopupTableRequestView class extending JetView for displaying a popup form.
 */
export default class popupTableRequestView extends JetView {
    /**
     * Configures the layout of the popup form.
     * @returns {Object} The configuration object for the popup view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Main information section configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'),
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'),
                    labelPosition: 'top',
                    placeholder: _('Tipo'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Date',
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'),
                    labelPosition: 'top',
                    placeholder: _('Fecha'),
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Monto'),
                    labelPosition: 'top',
                    placeholder: _('Monto'),
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Secondary information section configuration
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'PaymentSystemName',
                    label: _('Nombre sistema de pago'),
                    labelPosition: 'top',
                    placeholder: _('Nombre sistema de pago'),
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Left main section layout
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Right main section layout
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info],
        };

        // Upper section layout for larger screens
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }, rigth_main],
        };

        // Upper section layout for smaller screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info],
                },
            ],
        };

        // Return the complete popup configuration
        return {
            view: 'popup',
            rows: [screen !== 'small' ? upper_section : upper_section_narrow],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for the form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(
            this.app,
            'withdrawTransDetail:select',
            (person) => form.setValues(person), // Set form values based on selected person
        );
    }
}

// FILE DOCUMENTED
